<template>
  <tippy  class="inline-flex items-center justify-center cursor-help">
    <BaseIcon name="info" class="text-success hover:ring-success" />
    <template #content> <slot/> </template>
  </tippy>
</template>

<script setup>

</script>
